export default __webpack_public_path__ + "static/media/YAS0720.34I-34462_-18866_0.782bb9ed.jpg";